import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { HAuthService } from '@home/service/auth.service';
import { HMemberService } from '@home/service/member.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public tabIndex: number = 0;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private authService: HAuthService,
    private memberService: HMemberService
  ) { }

  ngOnInit(): void {
    // 회원 검증
    this.memberService.getMemberInfo().then( response => {

      // 비회원인 경우
      if ( response.ResultCode === false ) {
        this.toastrService.error('회원 로그인이 필요합니다.', '회원 서비스');
        this.router.navigate(
          ['/member/login'],
          {
            queryParams: {},
            relativeTo: this.activatedRoute,
            queryParamsHandling: '', // remove to replace all query params by provided
          }
        );

      // 회원인 경우 프리미엄 서비스 회원인지 검증한다.
      } else {
        // 프리미엄 서비스 회원인지 검증한다.
        if ( response.data.level <= 1 ) {
          this.toastrService.error('프리미엄 회원에게만 제공되는 서비스입니다.', '회원 서비스');
          this.router.navigate(
            ['/main'],
            {
              queryParams: {},
              relativeTo: this.activatedRoute,
              queryParamsHandling: '', // remove to replace all query params by provided
            }
          );
        }
      }

    });

  }

}
